<template>
  <div>
    <v-toolbar class="fixed-bar">
      <v-btn
        v-b-tooltip
        class="mr-3"
        title="Back to Safety Report"
        @click="$router.push('/safety/')"
        aria-label="Back to Safety Report"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>

      <v-spacer />

      <OptionsDropdown
        :items="exportItems"
        title="Export to SDF, Excel, Word or PDF"
      />
    </v-toolbar>

    <v-progress-linear
      v-if="downloading"
      indeterminate
    />

    <PubchemRecordsSection
      v-if="result"
      :result="result"
    />
  </div>
</template>

<script>
import PubchemRecordsSection from '@/components/pubchem/PubchemRecordsSection.vue'
import OptionsDropdown from '@/components/OptionsDropdown.vue'
import { download, getDatedFilename, getErrorMessage, RESOLVER_URL } from '@/main'
import { showErrorToast } from '@/utils/toast'

export default {
  components: { PubchemRecordsSection, OptionsDropdown },

  data: () => ({
    result: null,
    downloading: false,
  }),

  computed: {
    sid() {
      return this.$route.params.sid
    },
    section() {
      return this.$route.params.section
    },
    exportItems() {
      return [
        {
          title: 'Export to SDF',
          icon: 'mdi-file-download-outline',
          onClick: () => this.onExport('SDF'),
        },
        {
          title: 'Export to Excel',
          icon: 'mdi-file-excel-outline',
          onClick: () => this.onExport('XLSX'),
        },
        {
          title: 'Export to Word',
          icon: 'mdi-file-word-outline',
          onClick: () => this.onExport('DOCX'),
        },
        {
          title: 'Export to PDF',
          icon: 'mdi-file-pdf-box',
          onClick: () => this.onExport('PDF'),
        },
      ]
    },
  },

  methods: {
    getData() {
      let url = `${RESOLVER_URL}/pubchem-section?query=${this.sid}`
      if (this.section) url += `&section=${this.section}`
      else url += '&section=Safety%20and%20Hazards'
      this.$axios.get(url).then((response) => {
        this.result = response.data[0]
      })
    },
    onExport(format) {
      this.downloading = true
      this.$axios
        .post(
          `${RESOLVER_URL}/export-section`,
          {
            chemicals: [{ sid: this.sid }],
            sections: [this.section || 'Safety and Hazards'],
            outputFormat: format,
          },
          { responseType: 'blob' },
        )
        .then((response) => {
          let filename = getDatedFilename('safety', format.toLowerCase())
          download(filename, response.data, format.toLowerCase())
        })
        .catch((error) => {
          showErrorToast(error, { title: 'Error during export' })
        })
        .finally(() => {
          this.downloading = false
        })
    },
  },

  mounted() {
    this.getData()
  },
}
</script>
